import { 
    GET_DYNAMIC_PRICING_LIST, 
    GET_DYNAMIC_PRICING_BY_ID, 
    CREATE_DYNAMIC_PRICING, 
    UPDATE_DYNAMIC_PRICING, 
    DELETE_DYNAMIC_PRICING,
    GET_DYNAMIC_PRICING_FILTERS,
    SEARCH_DYNAMIC_PRICING,
    BULK_UPLOAD_DYNAMIC_PRICING,
    SYNC_DP_META
} from "../actionTypes/dynamicPricingActionTypes";
import { call, put, takeLatest, all } from "redux-saga/effects";
import { 
    getDynamicPricingListService, 
    getDynamicPricingByIdService, 
    createDynamicPricingService, 
    updateDynamicPricingService, 
    deleteDynamicPricingService,
    getDynamicPricingFiltersService,
    searchDynamicPricingService,
    bulkUploadDynamicPricingService,
    syncDpMetaService
} from "../services/dynamicPricingService";
import { toast } from "react-hot-toast";
import { 
    setDynamicPricingList, 
    setDynamicPricingDetails, 
    setDynamicPricingLoader,
    setDynamicPricingFilters
} from "../actionCreators/dynamicPricingActionCreator";

function* _getDynamicPricingList(_data: any) {
    try {
        yield put(setDynamicPricingLoader(true));
        const { data } = yield call(getDynamicPricingListService, _data.payload);
        yield put(setDynamicPricingLoader(false));
        console.log("DYNAMIC_PRICING_SAGA_RESPONSE:", data);
        if (data) {
            // Handle { data: [] }, Spring Boot Page { content: [] }, and direct array formats
            let dataList = data.data || data.content || (Array.isArray(data) ? data : []);
            let totalCount = data.totalCount !== undefined ? data.totalCount : (data.totalElements !== undefined ? data.totalElements : dataList.length);
            const formattedData = { data: dataList, totalCount: totalCount };
            yield put(setDynamicPricingList(formattedData));
        } else {
            _data.callback && _data.callback(data);
        }
    }
    catch (err: any) {
        yield put(setDynamicPricingLoader(false));
        console.error("_getDynamicPricingList: exceptionError: ", err);
        toast.error("Failed to fetch dynamic pricing list.");
    }
}

function* _getDynamicPricingById(_data: any) {
    try {
        yield put(setDynamicPricingLoader(true));
        const { data } = yield call(getDynamicPricingByIdService, _data.payload);
        yield put(setDynamicPricingLoader(false));
        if (data) {
            yield put(setDynamicPricingDetails(data));
            yield put(setDynamicPricingList({ data: [data], totalCount: 1 }));
            _data.callback && _data.callback(true);
        } else {
            yield put(setDynamicPricingList({ data: [], totalCount: 0 }));
            _data.callback && _data.callback(false);
        }
    } catch (err: any) {
        yield put(setDynamicPricingLoader(false));
        console.error("_getDynamicPricingById: exceptionError: ", err);
        yield put(setDynamicPricingList({ data: [], totalCount: 0 }));
        _data.callback && _data.callback(false);
        toast.error("Failed to fetch dynamic pricing details.");
    }
}

function* _createDynamicPricing(_data: any) {
    try {
        yield put(setDynamicPricingLoader(true));
        const { data } = yield call(createDynamicPricingService, _data.payload);
        yield put(setDynamicPricingLoader(false));
        if (data === true || data?.status === true) {
            toast.success("Dynamic pricing mapping created successfully.");
            _data.callback && _data.callback(true);
        } else {
            toast.error(data?.statusDescription || "Failed to create mapping.");
            _data.callback && _data.callback(false);
        }
    } catch (err: any) {
        yield put(setDynamicPricingLoader(false));
        console.error("_createDynamicPricing: exceptionError: ", err);
        toast.error("Something went wrong.");
        _data.callback && _data.callback(false);
    }
}

function* _updateDynamicPricing(_data: any) {
    try {
        yield put(setDynamicPricingLoader(true));
        const { data } = yield call(updateDynamicPricingService, _data.payload);
        yield put(setDynamicPricingLoader(false));
        if (data === true || data?.status === true) {
            toast.success("Dynamic pricing mapping updated successfully.");
            _data.callback && _data.callback(true);
        } else {
            toast.error(data?.statusDescription || "Failed to update mapping.");
            _data.callback && _data.callback(false);
        }
    } catch (err: any) {
        yield put(setDynamicPricingLoader(false));
        console.error("_updateDynamicPricing: exceptionError: ", err);
        toast.error("Something went wrong.");
        _data.callback && _data.callback(false);
    }
}

function* _deleteDynamicPricing(_data: any) {
    try {
        const { data } = yield call(deleteDynamicPricingService, _data.payload);
        if (data === true || data?.status === true) {
            toast.success("Mapping deleted successfully.");
            _data.callback && _data.callback(true);
        } else {
            toast.error(data?.statusDescription || "Failed to delete mapping.");
            _data.callback && _data.callback(false);
        }
    } catch (err: any) {
        console.error("_deleteDynamicPricing: exceptionError: ", err);
        toast.error("Something went wrong.");
    }
}

function* _getDynamicPricingFilters(_data: any) {
    try {
        const { data } = yield call(getDynamicPricingFiltersService, _data.payload);
        if (data) {
            yield put(setDynamicPricingFilters(data));
            _data.callback && _data.callback(data);
        } else {
            _data.callback && _data.callback(null);
        }
    } catch (err: any) {
        console.error("_getDynamicPricingFilters: exceptionError: ", err);
        _data.callback && _data.callback(null);
        toast.error("Failed to fetch filter options.");
    }
}

function* _searchDynamicPricing(_data: any) {
    try {
        yield put(setDynamicPricingLoader(true));
        const { data } = yield call(searchDynamicPricingService, _data.payload);
        yield put(setDynamicPricingLoader(false));
        if (data) {
            let dataList = data.data || data.content || (Array.isArray(data) ? data : []);
            let totalCount = data.totalCount !== undefined ? data.totalCount : (data.totalElements !== undefined ? data.totalElements : dataList.length);
            const formattedData = { data: dataList, totalCount: totalCount };
            yield put(setDynamicPricingList(formattedData));
            _data.callback && _data.callback(true);
        } else {
            yield put(setDynamicPricingList({ data: [], totalCount: 0 }));
            _data.callback && _data.callback(false);
        }
    } catch (err: any) {
        yield put(setDynamicPricingLoader(false));
        console.error("_searchDynamicPricing: exceptionError: ", err);
        toast.error("Failed to search dynamic pricing mappings.");
        yield put(setDynamicPricingList({ data: [], totalCount: 0 }));
        _data.callback && _data.callback(false);
    }
}

function* _bulkUploadDynamicPricing(_data: any) {
    try {
        yield put(setDynamicPricingLoader(true));
        const { data } = yield call(bulkUploadDynamicPricingService, _data.payload);
        yield put(setDynamicPricingLoader(false));
        if (data === true || data?.status === true) {
            _data.callback && _data.callback(true, data);
        } else {
            _data.callback && _data.callback(false, data);
        }
    } catch (err: any) {
        yield put(setDynamicPricingLoader(false));
        console.error("_bulkUploadDynamicPricing: exceptionError: ", err);
        const errorData = err?.response?.data || err.message;
        _data.callback && _data.callback(false, errorData);
    }
}

function* _syncDpMeta(_data: any) {
    try {
        const { data } = yield call(syncDpMetaService);
        if (data === true || data?.status === true) {
            toast.success("Sync Dynamic Pricing Meta triggered successfully.");
            _data.callback && _data.callback(true);
        } else {
            toast.error(data?.statusDescription || "Failed to sync metadata.");
            _data.callback && _data.callback(false);
        }
    } catch (err: any) {
        console.error("_syncDpMeta: exceptionError: ", err);
        toast.error("Something went wrong while syncing metadata.");
        _data.callback && _data.callback(false);
    }
}

export default function* dynamicPricingSaga() {
    yield all([
        takeLatest(GET_DYNAMIC_PRICING_LIST, _getDynamicPricingList),
        takeLatest(GET_DYNAMIC_PRICING_BY_ID, _getDynamicPricingById),
        takeLatest(CREATE_DYNAMIC_PRICING, _createDynamicPricing),
        takeLatest(UPDATE_DYNAMIC_PRICING, _updateDynamicPricing),
        takeLatest(DELETE_DYNAMIC_PRICING, _deleteDynamicPricing),
        takeLatest(GET_DYNAMIC_PRICING_FILTERS, _getDynamicPricingFilters),
        takeLatest(SEARCH_DYNAMIC_PRICING, _searchDynamicPricing),
        takeLatest(BULK_UPLOAD_DYNAMIC_PRICING, _bulkUploadDynamicPricing),
        takeLatest(SYNC_DP_META, _syncDpMeta),
    ]);
}
